import React, { useEffect, useState } from 'react';
import {
	AccordionContainer,
	AccordionItem,
	AccordionHeader,
	AccordionContent,
	Arrow,
	ChildList,
	ChildItem,
	TutorialLink,
	NoDataMessage,
} from './Accordion.styles';
import {
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import PlayIcon from '../../../assets/images/play.png';
import { Modal } from '../Modal/Modal';
import VideoPlayer from '../VideoPlayer';
import { getVideoMetaData } from 'utils/apiRequests';

const Accordion = ({ openAccordionId }) => {
	const [activeIndex, setActiveIndex] = useState(openAccordionId);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [videosData, setVideosData] = useState([]);
	const [loading, setLoading] = useState(false);

	const handleToggle = index => {
		setActiveIndex(activeIndex === index ? null : index);
	};

	useEffect(() => {
		setLoading(true);
		getVideoMetaData()
			.then(response => {
				setVideosData(response);
				setLoading(false);
			})
			.catch(error => {
				console.log(error, 'Error Message');
				setLoading(false);
			});
	}, []);

	const TutorialItem = ({ item }) => {
		return (
			<ChildItem
				onClick={() => {
					setIsModalOpen(item);
				}}
			>
				<div>
					<img src={PlayIcon} alt="play-icon" width="35px" height="35px" />
				</div>
				<TutorialLink>{item.headline}</TutorialLink>
			</ChildItem>
		);
	};

	return (
		<div
			style={{
				height: '63vh',
				marginRight: '0px',
				padding: !loading && videosData.length == 0 ? '35%' : '0%',
				overflowY: 'auto',
			}}
		>
			<AccordionContainer>
				{!loading && videosData.length > 0 ? (
					videosData.map((item, index) => {
						// Check if it's the "Speed to Market" tab
						if (
							item?.group === 'Speed To Market' &&
							item?.videos?.length === 6
						) {
							// Create a copy of the videos array
							const videos = [...item.videos];

							// Swap the 2nd and 3rd videos (index 1 and 2)
							[videos[1], videos[2]] = [videos[2], videos[1]];

							// Return the modified AccordionItem
							return (
								<AccordionItem key={index}>
									<AccordionHeader
										isActive={activeIndex === index}
										onClick={() => handleToggle(index)}
									>
										{item.group}
										<Arrow isActive={activeIndex === index}>
											<ApIcon iconName="keyboard_arrow_up" material={true} />
										</Arrow>
									</AccordionHeader>
									<AccordionContent isActive={activeIndex === index}>
										<ChildList>
											{videos.map((child, i) => (
												<TutorialItem key={i} item={child} />
											))}
										</ChildList>
									</AccordionContent>
								</AccordionItem>
							);
						} else {
							// Return the original AccordionItem if it's not the "Speed to Market" tab
							return (
								<AccordionItem key={index}>
									<AccordionHeader
										isActive={activeIndex === index}
										onClick={() => handleToggle(index)}
									>
										{item.group}
										<Arrow isActive={activeIndex === index}>
											<ApIcon iconName="keyboard_arrow_up" material={true} />
										</Arrow>
									</AccordionHeader>
									<AccordionContent isActive={activeIndex === index}>
										<ChildList>
											{item.videos.map((child, i) => (
												<TutorialItem key={i} item={child} />
											))}
										</ChildList>
									</AccordionContent>
								</AccordionItem>
							);
						}
					})
				) : loading ? (
					<>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</>
				) : (
					<NoDataMessage>videos unavailable!!</NoDataMessage>
				)}
			</AccordionContainer>

			{isModalOpen && (
				<Modal
					onClose={() => setIsModalOpen(false)}
					body={
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							<VideoPlayer videoName={isModalOpen} />
						</div>
					}
					title={isModalOpen?.headline}
					maxWidth={'80%'}
					suppressFooter
				/>
			)}
		</div>
	);
};

export default Accordion;
